export default __webpack_public_path__ + "static/Marcador-81b55e0dfc678ec30f47c4a1af96d9fa.svg";